import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Person } from '../../entities/master-data/person-entity';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

 

export class PersonRequest extends BaseRequest {
  person : Person;
  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.person = new Person();
  }
}